<div
  class="inline-flex h-20 w-11 flex-col items-center justify-center gap-1 rounded border border-black bg-white p-1"
  [class.!border-red-700]="isRedCard"
>
  <div class="flex h-6 w-6 flex-col items-center justify-center">
    <div class="text-2xl font-bold leading-9 text-black" [class.!text-red-700]="isRedCard">
      {{ label }}
    </div>
  </div>
  <div class="relative h-6 w-6">
    <svg-icon [svgClass]="'h-6 w-6'" [src]="svgUrl"></svg-icon>
  </div>
</div>
